<template>
  <div class="container">
    <div class="columns">
      <div class="column is-12">
        <section class="hero is-white is-small">
          <div class="hero-body">

            <section class="hero is-info welcome is-small">
              <div class="hero-body">
                <div class="container">
                  <h1 class="title">{{ activities.period.year }}年{{ activities.period.month }}月のご利用状況</h1>
                  <h2 class="subtitle">
                    <br>
                    ユーザー： <b>{{ userName }}</b>&nbsp;&nbsp;
                    アクセスキーID： <b v-if="accessKeyIDShown">{{ accessKeyID }}</b><b v-else>***************</b>
                    <a style="font-size: 0.8rem;" @click="accessKeyIDShown = !accessKeyIDShown">
                      <span v-if="accessKeyIDShown">非表示</span>
                      <span v-else>表示</span>
                    </a>
                  </h2>
                </div>
              </div>
            </section>
            <div class="columns account">
              <div class="column is-6">
                <section class="info-tiles">
                  <div class="tile is-ancestor has-text-centered">
                    <div class="tile is-parent">
                      <article class="tile is-child box">
                        <p class="title">{{ activities.scoring.count | toLocaleString }}</p>
                        <p class="subtitle">当月スコア付与件数</p>
                      </article>
                    </div>
                  </div>
                </section>
                <div class="card events-card">
                  <header class="card-header">
                    <p class="card-header-title">課金対象のご利用履歴</p>
                  </header>
                  <div class="card-table">
                    <div class="content">
                      <table class="table is-fullwidth is-striped">
                        <!--<thead>-->
                          <!--<tr>-->
                            <!--<th>状態</th>-->
                            <!--<th>スコア付与件数</th>-->
                            <!--<th>実行日時</th>-->
                          <!--</tr>-->
                        <!--</thead>-->
                        <tbody>
                          <tr v-for="scoring in activities.scoring.history" :key="scoring.created">
                            <td>{{ scoring.created }}</td>
                            <td>{{ scoring.meta.model.name }}</td>
                            <td>{{ scoring.meta.data_length }} 件</td>
                            <td>
                              <b-tag v-if="scoring.status === 'COMPLETE'" type="is-success">完了</b-tag>
                              <b-tag v-else-if="scoring.status === 'DELETED'" type="is-dark">削除済</b-tag>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <footer class="card-footer"></footer>
                </div>
              </div>
              <div class="column is-6">
                <section class="info-tiles">
                  <div class="tile is-ancestor has-text-centered">
                    <div class="tile is-parent">
                      <article class="tile is-child box">
                        <p class="title">&yen; {{ activities.billing.total | toLocaleString }}</p>
                        <p class="subtitle">当月ご利用料金</p>
                      </article>
                    </div>
                  </div>
                </section>
                <div class="card events-card">
                  <header class="card-header">
                    <p class="card-header-title">料金内訳</p>
                  </header>
                  <div class="card-table">
                    <div class="content">
                      <table class="table is-fullwidth is-striped">
                        <tbody>
                        <tr>
                          <td>基本料金</td>
                          <td>&yen; {{ activities.billing.basic | toLocaleString }}</td>
                        </tr>
                        <tr>
                          <td>スコアリング分課金&nbsp;&nbsp;<a style="font-size: 0.7rem;" @click="isPriceListModalActive = !isPriceListModalActive">料金表</a></td>
                          <td>&yen; {{ activities.billing.scoring_charge | toLocaleString }}</td>
                        </tr>
                        <tr>
                          <td>消費税（10%）</td>
                          <td>&yen; {{ activities.billing.tax | toLocaleString }}</td>
                        </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <footer class="card-footer"></footer>
                </div>
              </div>

            </div>

          </div>
        </section>
      </div>
    </div>

    <b-loading :is-full-page="loading.isFullPage"
               :active.sync="loading.isActive"
               :can-cancel="false"></b-loading>

    <b-modal :active.sync="isPriceListModalActive" scroll="clip" :width="640">
      <div class="card">
        <header class="card-header">
          <p class="card-header-title">SXスコア付与料金表（月額）</p>
        </header>
        <div class="card-content">
          <table class="table is-fullwidth price-list">
            <thead>
              <tr>
                <td v-for="column in priceList.columns" :key="column.field" :colspan="column.field === 'range' ? 3 : 1">{{ column.label }}</td>
              </tr>
            </thead>
            <tbody>
            <tr v-for="data in priceList.data" :key="data.min">
              <td style="text-align: right; width: 9rem;">{{ data.min }}</td>
              <td style="text-align: center; width: 1rem;">{{ data.to }}</td>
              <td style="text-align: left; width: 9rem;">{{ data.max }}</td>
              <td style="text-align: center;">{{ data.price }}</td>
              <td style="text-align: center;">{{ data.limit }}</td>
            </tr>
            </tbody>
          </table>
<!--          <b-table :data="priceList.data" :columns="priceList.columns"></b-table>-->
        </div>
      </div>
    </b-modal>
  </div>

</template>

<script>

import {activitiesRequest} from '../modules/request/account'

export default {
  name: 'User',
  components: {},
  data () {
    return {
      userName: '',
      accessKeyID: '',
      accessKeyIDShown: false,
      isPriceListModalActive: false,
      activities: {
        period: {
          year: 2000, month: 1
        },
        scoring: {
          count: 0, history: []
        },
        billing: {
          total: 0, basic: 0, scoring_charge: 0, tax: 0
        }
      },
      loading: {
        isFullPage: true,
        isActive: false,
        completed: false
      }
    }
  },
  computed: {
    priceList: function () {
      return {
        data: [
          {min: '1', to: '~', max: '50,000', price: 3, limit: '\xA5 150,000'},
          {min: '50,001', to: '~', max: '100,000', price: 2, limit: '\xA5 250,000'},
          {min: '100,001', to: '~', max: '200,000', price: 1, limit: '\xA5 350,000'},
          {min: '200,001', to: '~', max: '500,000', price: 0.3, limit: '\xA5 440,000'},
          {min: '500,001', to: '~', max: '1,000,000', price: 0.1, limit: '\xA5 490,000'},
          {min: '1,000,001', to: '~', max: '', price: 0.01, limit: ''}
        ],
        columns: [
          {field: 'range', label: 'スコア付与件数', centered: true},
          {field: 'price', label: '単価', centered: true},
          {field: 'limit', label: '上限価格', centered: true}
        ]
      }
    }
  },
  async created () {
    this.userName = this.$session.get('userName')
    this.accessKeyID = this.$session.get('accessKeyID')
    this.loading.isActive = true
    this.activities = await activitiesRequest(this)
  }
}
</script>

<style scoped>
  nav.navbar {
    border-top: 4px solid #276cda;
    margin-bottom: 1rem;
  }

  .navbar-item.brand-text {
    font-weight: 300;
  }

  .navbar-item, .navbar-link {
    font-size: 14px;
    font-weight: 700;
  }

  .columns {
    width: 100%;
    height: 100%;
    margin-left: 0;
  }

  .menu-label {
    color: #8F99A3;
    letter-spacing: 1.3;
    font-weight: 700;
  }

  .menu-list a {
    color: #0F1D38;
    font-size: 14px;
    font-weight: 700;
  }

  .menu-list a:hover {
    background-color: transparent;
    color: #276cda;
  }

  .menu-list a.is-active {
    background-color: transparent;
    color: #276cda;
    font-weight: 700;
  }

  .card {
    box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
    margin-bottom: 2rem;
  }

  .card-header-title {
    color: #8F99A3;
    font-weight: 400;
  }

  .info-tiles {
    margin: 1rem 0;
  }

  .info-tiles .subtitle {
    font-weight: 300;
    color: #8F99A3;
  }

  .hero.welcome.is-info {
    background: #36D1DC;
    background: -webkit-linear-gradient(to right, #5B86E5, #36D1DC);
    background: linear-gradient(to right, #5B86E5, #36D1DC);
  }

  .hero.welcome .title, .hero.welcome .subtitle {
    color: hsl(192, 17%, 99%);
  }

  .card .content {
    font-size: 14px;
  }

  .card-footer-item {
    font-size: 14px;
    font-weight: 700;
    color: #8F99A3;
  }

  .card-footer-item:hover {
  }

  .card-table .table {
    margin-bottom: 0;
  }

  .events-card .card-table {
    max-height: 250px;
    overflow-y: auto;
  }

  .columns.account {
    background: inherit;
    box-shadow: none;
  }

  table.price-list thead td {
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// src/views/Account.vue